

export const JSONServerUrl = 'https://json-pumpenwolf.wum-solution.tech'
